import { snakeCase } from 'lodash';

export const getActionType = (actionName, moduleName = 'COLLEGE_COSTS') =>
  `${moduleName}/${snakeCase(actionName).toUpperCase()}`;

export const createActionCreator = actionName => payload => ({
  type: getActionType(actionName),
  ...payload,
});
